<template>
    <v-container v-if="menu.length > 0"><v-app-bar fixed color="var(--vs-azul-primaria)" light elevation="0" height="30"
            style="border-bottom: 3px solid var(--vs-marrom-secundario) !important; margin-top: 64px;">
            <div class="container-menu-catalogo">
                <div>
                    <v-text class="custom-text-menu custom-text-menu-home" @click="limparFiltro">
                        Home
                    </v-text>
                    <v-menu offset-y v-for="menuItem in menu" :key="'vMenu1_' + menuItem.caiStrNome">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text class="custom-text-menu-with-padding" v-bind="attrs" v-on="on">{{
                                menuItem.caiStrNome.trim() }}</v-text>
                        </template>
                        <v-list v-if="menuItem.umNivel" style="min-width: 200px;">
                            <v-treeview id="v_treeview_umNivel" :style="styles" activatable :items="menuItem.estrutura"
                                @update:active="handleItemClick"></v-treeview>
                        </v-list>
                        <v-list v-else>
                            <v-treeview id="v_treeview" :style="styles" activatable :items="menuItem.estrutura"
                                @update:active="handleItemClick"></v-treeview>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </v-app-bar>
    </v-container>
</template>
  
<style>
#v_treeview .v-treeview-node__root {
    min-height: 1px;
    padding: 2px 10px 2px 2px !important;
    margin: 1px 1px 1px 1px;
    font-family: "Open Sans", sans-serif !important;
    font-size: 13px !important;
    cursor: pointer !important;
}

#v_treeview_umNivel .v-treeview-node__root {
    min-height: 1px;
    padding: 2px 10px 2px 0 !important;
    margin: 1px 1px 1px -15px;
    font-family: "Open Sans", sans-serif !important;
    font-size: 13px !important;
    cursor: pointer !important;
}

.custom-text-menu-with-padding {
    padding-right: 20px;
}

.container-menu-catalogo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: "Open Sans", sans-serif !important;
    font-size: 12px !important;
    color: #fff;
    width: 100%;
}

.custom-text-menu-home {
    padding-right: 20px;
}

.custom-text-menu {
    cursor: pointer;
    color: #fff;
    transition: color 0.2s;
}

.custom-text-menu:hover {
    color: rgba(220, 205, 205, 0.974);
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
    methods: {
        limparFiltro() {
            this.$store
                .dispatch("anuncio/filtrarCatalogos", { codFabricante: [], codEmpresa: this.$route.params.id })
                .then(() => {
                    this.hideLoading();
                })
                .catch(() => {
                    this.hideLoading();
                });
        },
        handleItemClick(activeItem) { 
            if (activeItem != undefined) {
                if (activeItem[0] != 0) {
                    const id = activeItem[0];
                    this.$store
                        .dispatch("anuncio/filtrarCatalogos", { codFabricante: [id], codEmpresa: this.$route.params.id })
                        .then(() => {
                            this.hideLoading();
                        })
                        .catch(() => {
                            this.hideLoading();
                        });
                }

            }
        },
    },
    computed: {
        ...mapGetters({

            menu: "cliente/menu",
        }),
    }
};
</script> 